class HttpError extends Error {
    statusCode;
    constructor(statusCode, message) {
        super(message);
        this.statusCode = statusCode;
        //https://www.dannyguo.com/blog/how-to-fix-instanceof-not-working-for-custom-errors-in-typescript
        Object.setPrototypeOf(this, HttpError.prototype);
    }
}
class JsonError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, JsonError.prototype);
    }
}
//we provide a custom fetch implementation that works
//like axios (ie. throws on errors)
const customFetch = async (url, init) => {
    const response = await fetch(url, {
        ...init,
        ...{
            headers: {
                'Content-Type': 'application/json',
            },
        },
    });
    if (!response.ok) {
        throw new HttpError(response.status, await response.text());
    }
    try {
        return JSON.parse(await response.text());
    }
    catch (e) {
        if (e instanceof Error) {
            throw new JsonError(e.message);
        }
        else {
            throw new JsonError(e);
        }
    }
};
//add some convenience methods
customFetch.get = async (url, init = { method: 'GET' }) => customFetch(url, init);
customFetch.delete = async (url, init = { method: 'DELETE' }) => customFetch(url, init);
customFetch.post = async (url, body, init = { method: 'POST', body: JSON.stringify(body) }) => customFetch(url, init);
customFetch.put = async (url, body, init = { method: 'PUT', body: JSON.stringify(body) }) => customFetch(url, init);
customFetch.patch = async (url, body, init = { method: 'PATCH', body: JSON.stringify(body) }) => customFetch(url, init);

export { HttpError, JsonError, customFetch as default };
//# sourceMappingURL=fetch.js.map
